export default __webpack_public_path__ + "static/media/schedule.4cd99044.svg";